import {
  Button,
  Column,
  ComboBox,
  DatePicker,
  DatePickerInput,
  FileUploader,
  Form,
  FormLabel,
  Grid,
  NumberInput,
  Row,
  TextArea,
  TextInput,
  Tile,
} from 'carbon-components-react';
import { Heading, Section } from 'carbon-components-react/lib/components/Heading';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import Padding from '../../components/Padding';
import UIShell from '../../components/UIShell';
import PageHelper from '../../helpers/Pagehelper';
import {
  EMPLOYEMENT_TYPE,
  EMPLOYEMENT_TYPE_UP,
  STATUSES,
  STATUSES_UP,
} from '../../utils/constants';
import { fetchAllCompanies } from '../../redux/actions/accountAction';
import { fetchAllCategory, fetchAllCategorySeletable } from '../../redux/actions/categoryAction';
import { createJob, getJob, updateJob } from '../../redux/actions/jobAction';
import { fetchAllSkillSelectable } from '../../redux/actions/skillAction';
import { generateYearExperienceOpts } from '../../helpers/GenerateExperience';
import { formatDate } from '../../utils/date';
import ReactQuill from 'react-quill';
import { RichTextInput } from '../../components/RichTextInput';

function JobFormPage({ isLoading, dataCategoriesSelectable, dataSkillsSelectable, dataCompanies }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { jobId } = useParams();

  const [initialImage, setInitialImage] = useState(null);

  const [formContent, setFormContent] = useState({
    jobId: undefined,
    accountId: undefined,
    title: undefined,
    description: undefined,
    jobCloses: undefined,
    type: undefined,
    onSiteRequired: undefined,
    skillsRequired: [],
    categories: [],
    minExperience: 1,
    status: undefined,
    image: undefined,
    deleteImage: false,
  });

  const uploadProfilePicture = (v) => {
    PageHelper.getBase64(v.target.files[0], (_result, _fileName, _fileSize) =>
      setFormContent((_state) => ({
        ..._state,
        image: {
          img: _result,
          name: _fileName,
          size: _fileSize,
        },
        deleteImage: false,
      }))
    );
    setInitialImage(null);
  };

  const submitForm = (e) => {
    e.preventDefault();

    const updatedFormContent = {
      ...formContent,
    };

    if (formContent.image && initialImage) {
      delete updatedFormContent.image;
      delete updatedFormContent.deleteImage;
    }

    if (jobId) {
      dispatch(
        updateJob(updatedFormContent, () => {
          history.push('/jobs');
        })
      );
    } else {
      dispatch(
        createJob(formContent, () => {
          history.push('/jobs');
        })
      );
    }
  };

  useEffect(async () => {
    dispatch(fetchAllCompanies());
    dispatch(fetchAllCategorySeletable());
    dispatch(fetchAllSkillSelectable());

    if (jobId && dataCategoriesSelectable.length) {
      dispatch(
        getJob({ jobId }, (_result) => {
          console.log({
            _result,
            // dataCategoriesSelectable
          });
          if (_result.image) {
            setInitialImage(_result.image);
          }
          setFormContent((_state) => ({
            ..._state,
            ..._result,
            accountId: _result.companyId,
            jobId: _result._id,
            categories: _result.categories?.map((v) => ({
              value: v,
              label: dataCategoriesSelectable.filter((cat) => cat.value === v)[0]?.label,
            })),
            skillsRequired: _result.skillsRequired?.map((v) => ({
              value: v,
              label: v,
            })),
            // images: _result.images ? _result.images?.map(v => ({
            //     img: v.url
            // })) : [],
            type: {
              value: _result.type,
              label:
                _result.type === EMPLOYEMENT_TYPE_UP.FULL_TIME
                  ? EMPLOYEMENT_TYPE.FULL_TIME
                  : EMPLOYEMENT_TYPE.PART_TIME,
            },
            onSiteRequired: {
              value: _result.onSiteRequired,
              label: _result.onSiteRequired ? 'Yes' : 'No',
            },
            minExperience: {
              value: _result.minExperience,
              label: _result.minExperience,
            },
            status: {
              value:
                _result.status === STATUSES_UP.PUBLISHED
                  ? STATUSES_UP.PUBLISHED
                  : STATUSES_UP.DRAFT,
              label: _result.status === STATUSES_UP.PUBLISHED ? STATUSES.PUBLISHED : STATUSES.DRAFT,
            },
            jobCloses: _result.jobCloses,
          }));
        })
      );
    }
  }, [dataCategoriesSelectable.length]);

  return (
    <UIShell
      breadcrumbs={[
        { name: 'Home', link: '/' },
        { name: 'Jobs', link: '/jobs' },
        { name: 'Create' },
      ]}>
      <Grid>
        <Row>
          <Column>
            <Tile>
              <Section style={{ margin: '1rem 0 4rem 0' }}>
                <Heading>Create Job By Company</Heading>
                <p>Description Create Job</p>
              </Section>
              <Form>
                <Padding bottom="2rem">
                  <ComboBox
                    // {...multiSelectProps}
                    titleText="Company"
                    placeholder="Select Company"
                    value={
                      formContent.accountId
                        ? dataCompanies.filter((v) => v.id === formContent.accountId)[0]?.text
                        : undefined
                    }
                    items={dataCompanies}
                    itemToString={(item) => (item ? item.text : '1')}
                    selectionFeedback={'top-after-reopen'}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        accountId: v?.selectedItem?.id,
                      }))
                    }
                    light
                  />
                </Padding>
                <TextInput
                  labelText="Title"
                  value={formContent.title}
                  onChange={(v) =>
                    setFormContent((_state) => ({
                      ..._state,
                      title: v.target.value,
                    }))
                  }
                  style={{ marginBottom: '2rem' }}
                  light
                />
                <RichTextInput
                  label="Description"
                  value={formContent.description}
                  onChange={(value) =>
                    setFormContent((prev) => ({
                      ...prev,
                      description: value,
                    }))
                  }
                  light
                  style={{ marginBottom: '2rem' }}
                />
                <DatePicker
                  dateFormat="m/d/Y"
                  datePickerType="single"
                  value={new Date(formContent.jobCloses)}
                  onChange={([startDate]) => {
                    setFormContent((_state) => ({
                      ..._state,
                      jobCloses: formatDate(startDate),
                    }));
                  }}
                  short={false}
                  style={{ marginBottom: '2rem' }}
                  light>
                  <DatePickerInput
                    id="date-picker-default-id"
                    placeholder="mm/dd/yyyy"
                    labelText="Application closes"
                    type="text"
                  />
                </DatePicker>
                <Padding bottom="2rem">
                  <FormLabel>Job type</FormLabel>
                  <Select
                    value={formContent.type}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        type: v,
                      }))
                    }
                    options={[
                      {
                        label: EMPLOYEMENT_TYPE.FULL_TIME,
                        value: EMPLOYEMENT_TYPE_UP.FULL_TIME,
                      },
                      {
                        label: EMPLOYEMENT_TYPE.PART_TIME,
                        value: EMPLOYEMENT_TYPE_UP.PART_TIME,
                      },
                    ]}
                  />
                </Padding>
                <Padding bottom="2rem">
                  <FormLabel>On site required?</FormLabel>
                  <Select
                    value={formContent.onSiteRequired}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        onSiteRequired: v,
                      }))
                    }
                    options={[
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ]}
                  />
                </Padding>

                <Padding bottom="2rem">
                  <FormLabel>Skills Required</FormLabel>
                  <Creatable
                    options={dataSkillsSelectable}
                    value={formContent.skillsRequired}
                    isMulti={true}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        skillsRequired: v,
                      }))
                    }
                  />
                </Padding>

                <Padding bottom="2rem">
                  <FormLabel>Categories</FormLabel>
                  <Select
                    isMulti={true}
                    value={formContent.categories}
                    options={dataCategoriesSelectable}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        categories: v,
                      }))
                    }
                  />
                </Padding>

                <Padding bottom="2rem">
                  <FormLabel>Min Experience</FormLabel>
                  <Select
                    value={formContent.minExperience}
                    options={generateYearExperienceOpts()}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        minExperience: v,
                      }))
                    }
                  />
                </Padding>

                <Padding top="2rem">
                  <FormLabel>Status</FormLabel>
                  <Select
                    value={formContent.status}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        status: v,
                      }))
                    }
                    options={[
                      {
                        label: STATUSES.PUBLISHED,
                        value: STATUSES_UP.PUBLISHED,
                      },
                      { label: STATUSES.DRAFT, value: STATUSES_UP.DRAFT },
                    ]}
                  />
                </Padding>
                <Padding top="2rem">
                  <FileUploader
                    accept={['.jpg', '.png']}
                    buttonKind="primary"
                    buttonLabel="Add Image"
                    filenameStatus="edit"
                    iconDescription="Clear file"
                    labelDescription="only .jpg and .png files at 500mb or less"
                    labelTitle="Upload Image"
                    style={{ marginBottom: '2rem' }}
                    onChange={uploadProfilePicture}
                    light
                    onDelete={() => {
                      setFormContent((_state) => ({
                        ..._state,
                        image: undefined,
                        deleteImage: true,
                      }));
                    }}
                    value={null}
                  />
                </Padding>

                <Padding bottom="2rem">
                  {formContent.image && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={formContent?.image?.img || formContent?.image}
                        style={{ width: 300, marginRight: 10, borderRadius: 5 }}
                        alt="Job Image"
                      />
                      {initialImage && (
                        <Button
                          kind="danger--tertiary"
                          onClick={() => {
                            setFormContent((_state) => ({
                              ..._state,
                              image: undefined,
                              deleteImage: true,
                            }));
                          }}>
                          Delete
                        </Button>
                      )}
                    </div>
                  )}
                </Padding>

                <Padding top="1rem">
                  <Button onClick={submitForm} disabled={isLoading} type="submit" kind="primary">
                    Save
                  </Button>
                  <Button onClick={() => history.push('/jobs')} kind="secondary">
                    Cancel
                  </Button>
                </Padding>
              </Form>
            </Tile>
          </Column>
        </Row>
      </Grid>
    </UIShell>
  );
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.uxReducer.isLoading,
    dataCategoriesSelectable: state.categoryReducer.dataCategoriesSelectable,
    dataSkillsSelectable: state.skillReducer.dataSkillsSelectable,
    dataCompanies: state.accountReducer.dataCompanies,
  };
};

export default connect(mapStateToProps)(JobFormPage);
